/**
 * Clone a node that has the same type as the original one
 * @param node
 */
export const cloneNode = (node, deep = true) => node.cloneNode(deep);
